import React from 'react'
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css'
import ReactDOM from "react-dom";

function CommonTooltip({ children, content, id, htmlContent = '', styles }) {
  return (
    <>
      <a
        data-tooltip-id={id}
        data-tooltip-content={content}
      >
        {children}
      </a>
      {ReactDOM.createPortal(
      <Tooltip className="z-[9999]" id={id} style={styles}>{htmlContent}</Tooltip>,
        document.body
      )}
    </>
  )
}

export default CommonTooltip